module.exports = __webpack_public_path__ + "assets/img/mlogo.107fada4.png";